"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clean = exports.flattenByObjectKey = exports.arrayOf = void 0;
const arrayOf = (n) => new Array(n).fill(undefined);
exports.arrayOf = arrayOf;
const flattenByObjectKey = (list, getArrayValue) => list
    .reduce((flattened, item) => [
    ...flattened,
    ...getArrayValue(item),
], []);
exports.flattenByObjectKey = flattenByObjectKey;
const clean = (array) => array.reduce((cleaned, item) => (item.trim().length > 0
    ? [...cleaned, item]
    : cleaned), []);
exports.clean = clean;
//# sourceMappingURL=array.js.map